export default {
      id: "from-usage",
      viewBox: "0 0 9 6",
      url: __webpack_public_path__ + "img/icons.svg#from",
      toString: function () {
        return this.url;
      }
    }